/* ============================================================
   DATA LABORATORIUM

   Letakkan di: app/layanan/laboratorium/lab.js

   ============================================================
   ⚠️ GANTI NAMA FOLDERNYA DULU

   Foldermu sekarang bernama `lab`, sementara menu Header menunjuk ke
   /layanan/laboratorium - itu sebabnya halamannya 404.

   Ganti nama app/layanan/lab/ menjadi app/layanan/laboratorium/,
   beserta isinya (images/1.jpg ikut pindah sendiri).

   Kenapa tidak sebaliknya - mengubah menu jadi /layanan/lab? Karena
   alamat yang dibaca manusia dan mesin pencari sebaiknya kata utuh.
   Orang mencari "laboratorium rumah sakit", bukan "lab rumah sakit".

   ============================================================
   BENTUK DATA - sama polanya dengan igd.js

   Halaman ini disusun mengikuti halaman IGD: kepala dua kolom
   beserta foto, kartu kontak, lalu galeri. Yang berbeda hanya
   isinya.
   ============================================================ */

import foto1 from "./images/1.jpg";

export const LAB = {
  /* Isi kalau jam pelayanannya sudah pasti, misalnya:
       jamLayanan: { id: "Senin-Sabtu, 07.00 - 20.00", en: "..." }
     Selama null, lencana jam di kepala halaman tidak dirender -
     lebih baik tanpa keterangan daripada jam karangan. */
  jamLayanan: null,

  /* Urutan menentukan urutan kartunya. Yang bertanda `utama` jadi
     tombol besar di kepala halaman dan tidak diulang sebagai kartu.

     Nomor dengan medan `wa` membuka WhatsApp beserta pesan pembuka;
     sisanya membuka aplikasi telepon. */
  telepon: [
    {
      label: { id: "Customer Service", en: "Customer Service" },
      tampil: "0811-901-874",
      tel: "+62811901874",
      wa: "62811901874",
      utama: true,
    },
    {
      label: { id: "Hunting", en: "Main line" },
      tampil: "(021) 798 0888",
      tel: "+62217980888",
      utama: false,
    },
  ],

  alamat: {
    baris: "Jl. Warung Buncit Raya No. 15, RT 10/RW 05, Kalibata, Kec. Pancoran, Jakarta Selatan 12740",
    /* Pencarian berdasarkan nama dan alamat, bukan koordinat - kalau
       titiknya digeser di Google Maps, tautannya tetap benar. */
    cari: "Rumah Sakit Jakarta Medical Center, Jl. Warung Buncit Raya No. 15, Jakarta Selatan",
  },
};

/* ============================================================
   PESAN PEMBUKA WHATSAPP

   Terisi otomatis di kolom ketik saat nomor customer service ditekan.
   WhatsApp hanya MENGISI, tidak mengirim - pasien masih bisa
   menyunting sebelum menekan kirim.

   Menyebutkan bahwa pertanyaannya soal laboratorium, supaya customer
   service langsung tahu konteksnya tanpa bertanya dulu.
   ============================================================ */
export const PESAN_WA = {
  id: "Halo RS Jakarta Medical Center,\n\nSaya ingin menanyakan informasi mengenai layanan laboratorium.\n\nMohon bantuannya. Terima kasih.",
  en: "Hello RS Jakarta Medical Center,\n\nI would like to ask about the laboratory services.\n\nThank you for your help.",
};

/* ============================================================
   JENIS PEMERIKSAAN

   MASIH KOSONG - tidak ada satu pun daftar pemeriksaan laboratorium
   yang pernah diberikan. Bagian "Pilihan Pemeriksaan" tidak dirender
   selama daftarnya kosong.

   Bentuknya sama dengan halaman MCU dan Swab, supaya kartunya
   seragam:

     {
       kode: "Darah",
       nama: { id: "Pemeriksaan darah lengkap", en: "Complete blood count" },
       julukan: { id: "Hasil 1 - 2 jam", en: "Results in 1 - 2 hours" },
       catatan: { id: "Perlu puasa 10 jam.", en: "Requires 10 hours of fasting." },
       harga: 150000,        // null -> kartunya menampilkan "Hubungi kami"
     },

   ⚠️ Kalau ada pemeriksaan yang menuntut puasa, tulis di `catatan`.
   Itu satu-satunya keterangan yang kalau hilang membuat pasien
   datang lalu harus pulang dan mengulang.
   ============================================================ */
export const PEMERIKSAAN = [];

export const FOTO = [
  {
    gambar: foto1,
    judul: { id: "Laboratorium RS JMC", en: "RS JMC Laboratory" },
    alt: {
      id: "Laboratorium Rumah Sakit Jakarta Medical Center.",
      en: "The laboratory at Jakarta Medical Center Hospital.",
    },
  },
];

/* Catatan operasional: syarat puasa, lama hasil keluar, apakah bisa
   tanpa rujukan dokter. Kosong dulu; bagiannya tidak dirender selama
   kosong. */
export const CATATAN = [];
